export default __webpack_public_path__ + "static/media/question-icon.dc6c61e9.svg";